<template lang="pug">
beautiful-chat#chat(
  :participants="participants",
  :titleImageUrl="titleImageUrl",
  :onMessageWasSent="onMessageWasSent",
  :messageList="messageList",
  :newMessagesCount="newMessagesCount",
  :isOpen="isChatOpen",
  :close="closeChat",
  :icons="icons",
  :open="openChat",
  :showEmoji="true",
  :showFile="true",
  :showEdition="true",
  :showDeletion="true",
  :showTypingIndicator="showTypingIndicator",
  :showLauncher="true",
  :showCloseButton="true",
  :colors="colors",
  :alwaysScrollToBottom="alwaysScrollToBottom",
  :messageStyling="messageStyling",
  @onType="handleOnType",
  @edit="editMessage"
)
  template(v-slot:header)
    img.sc-header--img(src="/favicon.png")
    div.sc-header--title(style="diplay: inline-block;") AI兔 & Me
</template>

<script>
import CloseIcon from "@/assets/vue-beautiful-chat/assets/close-icon.png";
import OpenIcon from "@/assets/vue-beautiful-chat/assets/logo-no-bg.svg";
import FileIcon from "@/assets/vue-beautiful-chat/assets/file.svg";
import CloseIconSvg from "@/assets/vue-beautiful-chat/assets/close.svg";
import conversation from "@/assets/conversation/conversation";
import chatbotLogic from "@/assets/conversation/chatbotLogic";

console.log(conversation);

export default {
  name: "Test",
  mounted() {
    console.clear();
    // console.log(chatbotLogic.calRecommendation())
  },
  data() {
    return {
      recommendation: {
        scene: null,
        title: "",
        item_id: null,
        sight: null
      },
      firstOpen: true,
      questionCount: 0,
      initMessages: conversation.initMessages,
      questions: conversation.questions,
      answers: {
        ans1: "ans1ooo"
      },
      icons: {
        open: {
          img: OpenIcon,
          name: "default"
        },
        close: {
          img: CloseIcon,
          name: "default"
        },
        file: {
          img: FileIcon,
          name: "default"
        },
        closeSvg: {
          img: CloseIconSvg,
          name: "default"
        }
      },
      participants: [
        {
          id: "bot",
          name: "AI兔",
          imageUrl:
            "/img/AI.png"
        }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl:
        "/favicon.png",
      messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "#4e8cff",
          text: "#ffffff"
        },
        launcher: {
          bg: "#4e8cff"
        },
        messageList: {
          bg: "#ffffff"
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff"
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222"
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867"
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    };
  },
  methods: {
    initiateConversation() {
      this.onMessageWasSent(this.initMessages[0]);
      let counter = 1;
      let initConversations = setInterval(() => {
        this.onMessageWasSent(this.initMessages[counter]);
        if (counter >= this.initMessages.length - 1) {
          console.log("clear counter");
          setTimeout(() => {
            this.onMessageWasSent(this.questions[this.questionCount]);
            this.questionCount = 1
            // this.questionCount += 1;
          }, 500);
          clearInterval(initConversations);
        }
        counter++;
      }, 500);
    },
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "bot",
          type: "text",
          data: { text }
        });
      }
    },
    onMessageWasSent(message) {
      // console.log(message);
      // console.log(message.author);
      // called when the user sends a message
      if (message.author === "bot") {
        this.showTypingIndicator = "true";
        setTimeout(() => {
          this.showTypingIndicator = "";
          this.messageList = [...this.messageList, message];
        }, 1000);
      } else {
        // 用戶回覆
        this.answers[`ans${this.questionCount}`] = message.data.text;
        this.messageList = [...this.messageList, message];
        if (this.questionCount < this.questions.length) {
          let reply = chatbotLogic.getReply(this.questionCount, this.answers[`ans${this.questionCount}`])
          if(reply){
            setTimeout(()=>{
              this.onMessageWasSent(reply)
            },500)
            setTimeout(()=>{
              this.onMessageWasSent(this.questions[this.questionCount-1]);
            },1000)
          }else{
            this.onMessageWasSent(this.questions[this.questionCount-1]);
          }
          this.questionCount += 1;
        } else {
          if (this.questionCount == this.questions.length) {
            // recommend logic here
            this.onMessageWasSent({
              type: "text",
              author: `bot`,
              data: {
                text: `吃飽了！有力氣分析數據了…`
              }
            });
            this.calculateResult();
            this.onMessageWasSent({
              type: "text",
              author: `bot`,
              data: {
                text: `經過AI兔的計算，為你推薦超讚的服務『${this.recommendation.title}』 以及超讚的台北景點：『${this.recommendation.sight_name}』`
              }
            });
            this.onMessageWasSent({
              type: "text",
              author: `bot`,
              data: {
                text: `趕快前往看看吧！`
              },
              suggestions: [
                "帶我去看看服務",
                "帶我去看看景點",
                "重新測驗一次"
              ]
            });
            this.questionCount += 1;
          } else if (
            this.questionCount >= this.questions.length + 1 &&
            message.data.text.includes("帶我去看看")
          ) {
            // this.questionCount = 0;
            this.closeChat();
            console.log("go to item");
            if (message.data.text.includes("服務")) {
              try {
                this.$router.push({
                  name: "Home",
                  query: {
                    sight: ""
                  }
                });
              } catch (e) {
                console.log(e);
              }
              setTimeout(() => {
                this.$router.push({
                  name: "Home",
                  query: {
                    scene: this.recommendation.scene,
                    itemIndex: this.recommendation.item_id
                  }
                });
              }, 500);
            } else {
              try {
                this.$router.push({
                  name: "Explore",
                  query: {
                    sight: ""
                  }
                });
              } catch (e) {
                console.log(e);
              }
              setTimeout(() => {
                this.$router.push({
                  name: "Explore",
                  query: {
                    sight: this.recommendation.sight
                  }
                });
              }, 500);
            }
            this.onMessageWasSent({
              type: "text",
              author: `bot`,
              data: {
                text: "還想要再玩一次嗎?"
              },
              suggestions: [
                "帶我去看看服務",
                "帶我去看看景點",
                "重新測驗一次"
              ]
            });
          } else {
            console.log("restart");
            console.log(this.questionCount);
            console.log(this.questions.length);
            this.questionCount = 0;
            this.onMessageWasSent(this.questions[this.questionCount]);
            this.questionCount += 1;
          }
        }
      }
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      if (this.firstOpen) {
        this.initiateConversation();
        this.firstOpen = false;
      }
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      console.log("Emit typing event");
    },
    editMessage(message) {
      const m = this.messageList.find(m => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
    calculateResult() {
      this.recommendation = chatbotLogic.calRecommendation(this.answers)
    }
  }
};
</script>

<style lang="sass">
#chat
  .sc-launcher
    background-color: #63D2D1 !important
  .sc-launcher, .sc-open-icon
    bottom: 50px
    .sc-closed-icon
      bottom: 50px
  .sc-chat-window, .sc-launcher
    z-index: 1001
  .sc-header
    align-items: center
  .sc-header--img
    height: 50px
    width: auto
  .sc-header--title
    font-size: 20px
    padding: 10px
    align-self: center
  .sc-message
    width: 330px
  .sc-message--text, .sc-message--file-text
    white-space: pre-wrap
  .sc-message--avatar
    min-width: 50px
    min-height: 50px
    margin-right: 5px
    background-color: #62CBCC
    background-size: 130%
  form.sc-user-input
    display: none !important
  .sc-suggestions-row
    padding: 1rem
  .sc-message--text
    margin-right: 20px
  .sc-message--text p
    margin: 0
</style>
